var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c(
        "el-select",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.getReadMode(),
              expression: "!getReadMode()",
            },
          ],
          ref: "fieldEditor",
          staticClass: "full-width-input",
          attrs: {
            disabled: _vm.field.options.disabled,
            size: _vm.field.options.size,
            clearable: _vm.field.options.clearable,
            filterable: _vm.field.options.filterable,
            "allow-create": _vm.field.options.allowCreate,
            "default-first-option": _vm.allowDefaultFirstOption,
            "automatic-dropdown": _vm.field.options.automaticDropdown,
            multiple: _vm.field.options.multiple,
            "multiple-limit": _vm.field.options.multipleLimit,
            placeholder:
              _vm.field.options.placeholder ||
              _vm.i18nt("render.hint.selectPlaceholder"),
            remote: _vm.field.options.remote,
            "remote-method": _vm.remoteMethod,
          },
          on: {
            focus: _vm.handleFocusCustomEvent,
            blur: _vm.handleBlurCustomEvent,
            change: _vm.handleChangeEvent,
          },
          model: {
            value: _vm.fieldModel,
            callback: function ($$v) {
              _vm.fieldModel = $$v
            },
            expression: "fieldModel",
          },
        },
        _vm._l(_vm.field.options.optionItems, function (item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              label: item.label,
              value: item.value,
              disabled: item.disabled,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.getReadMode()
        ? [
            _c("div", { staticClass: "readonly-mode-field" }, [
              _vm._v(_vm._s(_vm.contentForReadMode || "--")),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }